module.exports = __webpack_public_path__ + "static/img/restaurant-main-img.a7f4de22.svg";